var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipPad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.767,
    height: 18.291,
    viewBox: "0 0 16.767 18.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip_pad",
    transform: "translate(-315.984 -605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M319.414,617.812a3.243,3.243,0,0,0,3.239,3.239h7.05v1.334a2.1,2.1,0,0,1-2.1,2.1H318.08a2.1,2.1,0,0,1-2.1-2.1V612.1a2.1,2.1,0,0,1,2.1-2.1h1.334v7.812Z",
    transform: "translate(0 -1.189)",
    fill: "#e2e2e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M334.178,607.1a2.1,2.1,0,0,0-2.1-2.1h-8a2.1,2.1,0,0,0-2.1,2.1v9.526a2.1,2.1,0,0,0,2.1,2.1h8a2.1,2.1,0,0,0,2.1-2.1Z",
    transform: "translate(-1.427)",
    fill: "#a8a8a8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipPad);
export default __webpack_public_path__ + "static/media/clip_pad.2217258175c3a7929a5c95b9eb11ddd9.svg";
export { ForwardRef as ReactComponent };